export default __webpack_public_path__ + "static/media/Blog-4.21c4506b.png";